// extracted by mini-css-extract-plugin
export default {"cls1":"index-cls1___7b33f9fb160ba03e8f5","cls2":"index-cls2___ca2bbe874d6060b9260 index-cls1___7b33f9fb160ba03e8f5"};